import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Star, Trash2, Eye, EyeOff } from "lucide-react";
import { api, apiError } from "@/lib/api";

export default function FeedbackPanel() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/feedback").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const toggle = async (f) => {
    try { await api.post(`/admin/feedback/${f.id}/approve`); toast.success(f.approved ? "Recensione nascosta" : "Recensione pubblicata in home"); load(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  const remove = async (f) => {
    if (!window.confirm("Eliminare questo feedback?")) return;
    try { await api.delete(`/admin/feedback/${f.id}`); load(); } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <div data-testid="feedback-panel" className="border border-neutral-200 rounded-2xl p-4">
      <h2 className="font-display font-bold mb-1">Feedback ricevuti</h2>
      <p className="text-xs text-neutral-500 mb-3">Dalla schermata d'accesso. Pubblica quelli che vuoi mostrare come recensioni in home.</p>
      <div className="space-y-2">
        {(items || []).map((f) => (
          <div key={f.id} data-testid={`feedback-${f.id}`} className="border border-neutral-100 rounded-xl p-3">
            <div className="flex items-center justify-between gap-2">
              <div className="min-w-0">
                <p className="text-sm font-semibold truncate">{f.name} {f.email && <span className="text-neutral-400 font-normal">· {f.email}</span>}</p>
                <div className="flex items-center gap-0.5">{[1, 2, 3, 4, 5].map((n) => <Star key={n} size={12} className={n <= f.rating ? "fill-[#E0B94B] text-[#E0B94B]" : "text-neutral-300"} />)}</div>
              </div>
              <div className="flex items-center gap-1 shrink-0">
                <button data-testid={`feedback-toggle-${f.id}`} onClick={() => toggle(f)} title={f.approved ? "Nascondi" : "Pubblica in home"}
                  className={`p-2 rounded-full ${f.approved ? "bg-green-50 text-green-700" : "text-neutral-400 hover:text-black"}`}>{f.approved ? <Eye size={16} /> : <EyeOff size={16} />}</button>
                <button data-testid={`feedback-delete-${f.id}`} onClick={() => remove(f)} className="p-2 text-neutral-300 hover:text-red-500"><Trash2 size={16} /></button>
              </div>
            </div>
            <p className="text-sm mt-1">{f.message}</p>
            <p className="text-[10px] text-neutral-400 mt-1">{new Date(f.created_at).toLocaleString("it-IT")} {f.approved && "· pubblicato"}</p>
          </div>
        ))}
        {items && items.length === 0 && <p data-testid="feedback-empty" className="text-xs text-neutral-400">Nessun feedback ancora.</p>}
      </div>
    </div>
  );
}
